import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../../contexts/AuthContext';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5001/api';

function AdminSystem() {
  const { session } = useAuth();
  const [health, setHealth] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchHealth = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`${API_BASE_URL}/admin/system/health`, {
        headers: { 'Authorization': `Bearer ${session.access_token}` }
      });
      const result = await res.json();
      if (result.success) setHealth(result.data);
      else setError(result.error);
    } catch (e) { setError('检查失败'); }
    finally { setLoading(false); }
  }, [session]);

  useEffect(() => { if (session) fetchHealth(); }, [session, fetchHealth]);

  const isOk = (svc) => svc.status === 'ok';
  const statusColor = (svc) => isOk(svc) ? 'var(--green)' : 'var(--red)';
  const statusText = (svc) => isOk(svc) ? '正常' : '异常';

  return (
    <div>
      <div className="ad-term">
        <div className="ad-term-bar">
          <div className="ad-term-dots">
            <span className="ad-term-dot ad-term-dot--red" />
            <span className="ad-term-dot ad-term-dot--yellow" />
            <span className="ad-term-dot ad-term-dot--green" />
          </div>
          <span className="ad-term-title">system_health</span>
        </div>
        <div className="ad-term-body">
          {loading ? (
            <div className="ad-loading">检查中...</div>
          ) : error ? (
            <div className="ad-error">{error}</div>
          ) : health ? (
            <>
              <div className="ad-stats-grid" style={{ marginBottom: 20 }}>
                {Object.entries(health).map(([name, svc]) => (
                  <div className="ad-stat-card" key={name}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                      <span style={{
                        width: 8, height: 8, borderRadius: '50%',
                        backgroundColor: statusColor(svc),
                        display: 'inline-block', flexShrink: 0
                      }} />
                      <span style={{ fontFamily: 'var(--font-mono)', fontSize: 13, fontWeight: 600, color: 'var(--text-1)' }}>
                        {name}
                      </span>
                    </div>
                    <div style={{ fontFamily: 'var(--font-mono)', fontSize: 12, color: statusColor(svc) }}>
                      {statusText(svc)}
                    </div>
                    {svc.responseTime != null && (
                      <div style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--text-3)', marginTop: 4 }}>
                        响应: {svc.responseTime}ms
                      </div>
                    )}
                    {svc.error && (
                      <div style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--red)', marginTop: 4 }}>
                        {svc.error}
                      </div>
                    )}
                  </div>
                ))}
              </div>

              <div style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--text-3)' }}>
                检查时间: {new Date().toLocaleString('zh-CN')}
              </div>
            </>
          ) : null}

          <button
            className="ad-nav-btn"
            style={{ marginTop: 16 }}
            onClick={fetchHealth}
            disabled={loading}
          >
            {loading ? '检查中...' : '重新检查'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AdminSystem;
